// src/pages/Arguente/RegistrarArguentePage.jsx
import React from 'react';
import ArguenteForm from '../../components/Arguente/ArguenteForm';

const RegistrarArguentePage = () => {
    return (
        <div>
            <h1>Registrar Arguente</h1>
            <ArguenteForm onSuccess={() => alert('Arguente registrado com sucesso!')} />
        </div>
    );
};

export default RegistrarArguentePage;